import { ProgressBar } from '@components/progress';
import { Typography } from '@components/typography';
import type { DatasetJob } from '@generated/graphql';
import { Stack, capitalize } from '@mui/material';
import { getJobCompletionPercentage } from '@utils/jobs';
import { navigate } from 'gatsby';
import { memo, useMemo } from 'react';

interface RecentJobPreviewProps {
  job: DatasetJob;
}

export const RecentJobPreview = memo(
  ({ job: { status, name, estimatedEndAt, createdAt, datasetId } }: RecentJobPreviewProps) => {
    const percent = useMemo(() => {
      return getJobCompletionPercentage(status, estimatedEndAt, createdAt);
    }, [status, createdAt, estimatedEndAt]);

    return (
      <Stack>
        <Typography
          variant="body2"
          handleOverFlow
          onClick={() => navigate('jobs', { state: { jobId: datasetId } })}
          sx={{ cursor: 'pointer' }}
        >
          {name || '-'}
        </Typography>
        <ProgressBar
          percent={percent}
          error={status === 'failed'}
          warning={status === 'timeout'}
          label={capitalize(status)}
        />
      </Stack>
    );
  },
);
